import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {AccountReportSelectionControlData} from "../../account/controls/account-report-selection-control.component";

export class ExpAccDetailReportData extends ReportData<ExpAccDetailReportData> {
    @field summary: boolean = true;
    @collection(AccountReportSelectionControlData) accounts: AccountReportSelectionControlData[];
}
